module.exports = __webpack_public_path__ + "media/images/emblems/CH_Mont-Vully_COA-8334b51a64d108162c97a0d9bbc16402.svg";